module.exports = __webpack_public_path__ + "img/img_webinar3.a84bd395.jpg";